"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPerPersonPricingSummary = exports.getOrderLinesToJSON = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-spread */
const dayjs = require("dayjs");
const calendar = require("dayjs/plugin/calendar");
const currencyFormatter_1 = require("../currencyFormatter");
const pluralize_1 = require("../pluralize");
const expandOrderItems_1 = require("./expandOrderItems");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderDisplayCurrency_1 = require("./getOrderDisplayCurrency");
const groupOrderLinesByDate_1 = require("./groupOrderLinesByDate");
const getTotalVariantValue_1 = require("./getTotalVariantValue");
const getVariantDisplayTotal_1 = require("./getVariantDisplayTotal");
const getVariantCurrency_1 = require("./getVariantCurrency");
const getOrderLineTotalByType_1 = require("./getOrderLineTotalByType");
const hotel_1 = require("../hotel");
const getRoomRateSummary_1 = require("./getRoomRateSummary");
const course_1 = require("../course");
const getVariantPricingBands_1 = require("./getVariantPricingBands");
const expandItemProcessors_1 = require("./expandItemProcessors");
dayjs.extend(calendar);
const getOrderLinesToJSON = (order, variant, order_id, exchange_rate, transaction_fee, hide_cancelled, include_data = false) => {
    const orderLines = variant?.order_lines?.filter((line) => {
        if (!line.versions)
            return false;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return false;
        if (hide_cancelled &&
            order.status &&
            latest_version.status.includes("CANCELLED") &&
            !order.status.includes("CANCELLED"))
            return false;
        return true;
    });
    if (!orderLines)
        return null;
    if (!order_id)
        return null;
    const expanded_items = (0, expandOrderItems_1.expandOrderItems)(orderLines);
    const lines = (0, expandItemProcessors_1.expandedItemProcessor)(expanded_items, order, include_data, exchange_rate);
    let grouped_lines = (0, groupOrderLinesByDate_1.groupOrderLinesByDate)(lines.order_lines);
    // get all the order_lines arrays and flatten them into one array
    let flattened_lines = grouped_lines.map((line) => line.order_lines);
    flattened_lines = [].concat.apply([], flattened_lines);
    const golfLines = flattened_lines.filter((line) => line.type === "GOLF" && line.line_type === "LINE_ITEM");
    const extrasLines = flattened_lines
        .filter((line) => {
        // let config = latest_version.config as unknown as CustomOrderLine
        return line.type === "CUSTOM" && line.line_type === "LINE_ITEM";
    })
        .filter((line) => {
        const latest_version = line.latest_version;
        const config = latest_version.config;
        return config?.where_when_who?.type === "EXTRA";
    });
    // remove the extras from the grouped lines
    grouped_lines = grouped_lines.map((line) => {
        line.order_lines = line.order_lines.filter((line) => {
            if (line.type === "CUSTOM") {
                const latest_version = line.latest_version;
                const config = latest_version.config;
                return config?.where_when_who?.type !== "EXTRA";
            }
            return true;
        });
        return line;
    });
    const per_person_pricing = (0, exports.getPerPersonPricingSummary)(flattened_lines, exchange_rate);
    return {
        order_id: order_id,
        variant: {
            id: variant?.id,
            name: variant?.name,
        },
        itinerary: {
            items: grouped_lines,
            extras: extrasLines,
            fees: {
                credit_card_fee: transaction_fee || 0,
            },
            per_person_pricing: per_person_pricing,
            pay_at_course_extras: getPayAtCourseExtrasSummary(golfLines, exchange_rate),
            pricing_bands: (0, getVariantPricingBands_1.getVariantPricingBands)(variant),
            total: {
                currency: (0, getVariantCurrency_1.getVariantCurrency)(variant),
                processing_fee: (0, getTotalVariantValue_1.getTotalVariantValue)(variant) * ((transaction_fee || 0) / 100),
                processing_fee_formatted: (0, currencyFormatter_1.currencyFormatter)((0, getVariantCurrency_1.getVariantCurrency)(variant) || "", (0, getTotalVariantValue_1.getTotalVariantValue)(variant) * ((transaction_fee || 0) / 100) || 0, false),
                total_price: (0, getTotalVariantValue_1.getTotalVariantValue)(variant),
                total_price_formatted: (0, currencyFormatter_1.currencyFormatter)((0, getVariantCurrency_1.getVariantCurrency)(variant) || "", (0, getTotalVariantValue_1.getTotalVariantValue)(variant), false),
                display_currency: (0, getOrderDisplayCurrency_1.getOrderDisplayCurrency)(exchange_rate),
                display_total_price: (0, getVariantDisplayTotal_1.getVariantDisplayTotal)(variant, exchange_rate),
                display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)((0, getOrderDisplayCurrency_1.getOrderDisplayCurrency)(exchange_rate), (0, getVariantDisplayTotal_1.getVariantDisplayTotal)(variant, exchange_rate), false),
            },
        },
    };
};
exports.getOrderLinesToJSON = getOrderLinesToJSON;
const getPayAtCourseExtrasSummary = (orderLines, exchange_rate) => {
    let rate = 1;
    if (!exchange_rate || exchange_rate?.rate === 1) {
        rate = 0;
    }
    else {
        rate = exchange_rate.rate;
    }
    const extras = orderLines.map((line) => {
        const config = line?.latest_version.config;
        const extras = (0, course_1.getPayAtCourseExtras)(config);
        if (!extras)
            return null;
        return {
            title: extras.title,
            currency: line.currency,
            total_price: extras?.price || 0,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(line.currency, extras?.price || 0, false),
            total_price_per_person: (Number(extras?.price || 0) / line.pax).toFixed(2),
            total_price_per_person_formatted: (0, currencyFormatter_1.currencyFormatter)(line.currency, Number(extras?.price || 0) / line.pax, false),
            display_currency: line.display_currency,
            display_total_price: Number(extras?.price || 0) * rate,
            display_price_per_person: ((Number(extras?.price || 0) * rate) /
                line.pax).toFixed(2),
            display_price_per_person_formatted: (0, currencyFormatter_1.currencyFormatter)(line.display_currency, (Number(extras?.price || 0) * rate) / line.pax, false),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(line.display_currency, Number((Number(extras?.price || 0) * rate).toFixed(2)), false),
            details: dayjs(config.where_when_who?.date).format("ddd, Do MMMM, YYYY"),
        };
    });
    return extras.filter((extra) => extra !== null);
};
const getPerPersonPricingSummary = (orderLines, exchange_rate) => {
    const pricing_summary = [];
    const items_summary = [];
    let rate = 1;
    let footnote = "";
    if (!exchange_rate || exchange_rate?.rate === 1) {
        rate = 0;
    }
    else {
        rate = exchange_rate.rate;
    }
    orderLines = orderLines.filter((line) => line.line_type === "LINE_ITEM");
    const hotelLines = orderLines.filter((line) => line.type === "HOTEL" && line.line_type === "LINE_ITEM");
    const transferLines = orderLines.filter((line) => line.type === "TRANSFER" && line.line_type === "LINE_ITEM");
    const golfLines = orderLines.filter((line) => line.type === "GOLF" && line.line_type === "LINE_ITEM");
    const excursionLines = orderLines.filter((line) => line.type === "EXCURSION" && line.line_type === "LINE_ITEM");
    const golf_transfers = transferLines.filter((line) => {
        const config = line?.latest_version.config;
        return (config?.transfer_legs?.outbound?.to_type === "Course" ||
            config?.transfer_legs?.outbound?.from_type === "Course");
    });
    const hotel_transfers = transferLines.filter((line) => {
        const config = line?.latest_version.config;
        return ((config?.transfer_legs?.outbound?.to_type === "Hotel" ||
            config?.transfer_legs?.outbound?.from_type === "Hotel") &&
            config?.transfer_legs?.outbound?.to_type !== "Course");
    });
    const customLines = orderLines.filter((line) => {
        // let config = latest_version.config as unknown as CustomOrderLine
        return line.type === "CUSTOM" && line.line_type === "LINE_ITEM";
    });
    const pax_array = orderLines
        .filter((line) => line.line_type === "LINE_ITEM")
        .map((line) => {
        return line.pax;
    });
    const golf_pax_array = orderLines
        .filter((line) => line.line_type === "LINE_ITEM" && line.type === "GOLF")
        .map((line) => {
        return line.pax;
    });
    // get the min and max from the pax array
    const golf_min_max_pax = {
        min_pax: Math.min(...golf_pax_array),
        max_pax: Math.max(...golf_pax_array),
    };
    const hotel_pax_array = orderLines
        .filter((line) => line.line_type === "LINE_ITEM" && line.type === "HOTEL")
        .map((line) => {
        return line.pax;
    });
    const hotel_min_max_pax = {
        min_pax: Math.min(...hotel_pax_array),
        max_pax: Math.max(...hotel_pax_array),
    };
    const custom_pax_array = customLines
        .filter((line) => line.line_type === "LINE_ITEM" && line.type === "CUSTOM")
        .map((line) => {
        return line.pax;
    });
    const custom_min_max_pax = {
        min_pax: Math.min(...custom_pax_array),
        max_pax: Math.max(...custom_pax_array),
    };
    const excursions_pax_array = orderLines
        .filter((line) => line.line_type === "LINE_ITEM" && line.type === "EXCURSION")
        .map((line) => {
        return line.pax;
    });
    const excursions_min_max_pax = {
        min_pax: Math.min(...excursions_pax_array),
        max_pax: Math.max(...excursions_pax_array),
    };
    const hotel_transfer_pax_array = hotel_transfers
        .filter((line) => line.line_type === "LINE_ITEM" && line.type === "TRANSFER")
        .map((line) => {
        return line.pax;
    });
    // get the min and max from the pax array
    const hotel_transfers_min_max_pax = {
        min_pax: Math.min(...hotel_transfer_pax_array),
        max_pax: Math.max(...hotel_transfer_pax_array),
    };
    const golf_transfer_pax_array = golf_transfers
        .filter((line) => line.line_type === "LINE_ITEM" && line.type === "TRANSFER")
        .map((line) => {
        return line.pax;
    });
    // get the min and max from the pax array
    const golf_transfers_min_max_pax = {
        min_pax: Math.min(...golf_transfer_pax_array),
        max_pax: Math.max(...golf_transfer_pax_array),
    };
    const isOnePax = pax_array.every((val, i, arr) => val === 1);
    const hasEqualPax = pax_array.every((val, i, arr) => val === arr[0]);
    const hasEqualGolfPax = golf_pax_array.every((val, i, arr) => val === arr[0]);
    const hasEqualHotelPax = hotel_pax_array.every((val, i, arr) => val === arr[0]);
    const hasEqualExcursionsPax = excursions_pax_array.every((val, i, arr) => val === arr[0]);
    const hasEqualHotelTransferPax = hotel_transfer_pax_array.every((val, i, arr) => val === arr[0]);
    const hasEqualGolfTransferPax = golf_transfer_pax_array.every((val, i, arr) => val === arr[0]);
    // Has Hotel, Hotel Transfers, Excursions and any custom lines got the same pax and greater than the golf pax
    // does the hotel_min_max_pax.max_pax, hotel_transfers_min_max_pax.max_pax, excursions_min_max_pax.max_pax all match
    const all_but_golf_pax_array = [
        hotel_min_max_pax.max_pax,
        hotel_transfers_min_max_pax.max_pax,
        excursions_min_max_pax.max_pax,
        custom_min_max_pax.max_pax,
    ];
    const doesEverythingButGolfAndGolfTransfersMatchPax = hasEqualHotelPax &&
        hasEqualHotelTransferPax &&
        hasEqualExcursionsPax &&
        all_but_golf_pax_array.every((val, i, arr) => {
            if (val === Infinity || val === -Infinity)
                return true;
            return val === arr[0];
        });
    const hasGolfAndGolfTransfersMatchPax = hasEqualGolfPax &&
        hasEqualGolfTransferPax &&
        golf_min_max_pax.max_pax === golf_transfers_min_max_pax.max_pax;
    const hotelRoomsSame = hotelLines.every((val, i, arr) => {
        const hotel_config = val.latest_version.config;
        const rooms = hotel_config?.rooms?.rooms;
        // is the room.id, occupancy and board the same for all the rooms
        return rooms.every((room, i, arr) => {
            return (room.room.id === arr[0].room.id &&
                room.occupancy === arr[0].occupancy &&
                room.board === arr[0].board);
        });
    });
    // get the min and max from the pax array
    const order_min_max_pax = {
        min_pax: Math.min(...pax_array),
        max_pax: Math.max(...pax_array),
    };
    const golf_pricing = golfLines.reduce((acc, a) => acc + Number(a.total_price), 0);
    const golf_transfer_pricing = golf_transfers.reduce((acc, a) => acc + Number(a.total_price), 0);
    const hotel_transfer_pricing = hotel_transfers.reduce((acc, a) => acc + Number(a.total_price), 0);
    const hotel_pricing = hotelLines.reduce((acc, a) => acc + Number(a.total_price), 0);
    const excursion_pricing = excursionLines.reduce((acc, a) => acc + Number(a.total_price), 0);
    const custom_pricing = customLines.reduce((acc, a) => acc + Number(a.total_price), 0);
    const total_price = orderLines.reduce((acc, a) => acc + Number(a.total_price), 0);
    const display_total_price = orderLines.reduce((acc, a) => acc + Number(a.display_total_price), 0);
    const total_excluding_hotel = total_price - hotel_pricing;
    const total_excluding_golf_and_golf_transfers = total_price - golf_pricing - golf_transfer_pricing;
    // Hotel Lines
    hotelLines.forEach((line) => {
        const hotel_config = line.latest_version
            .config;
        const line_total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(hotel_config, "HOTEL");
        // get the unique rooms for the line
        const line_unique_rooms = [];
        const rooms = hotel_config?.rooms?.rooms;
        // Adjustments
        const custom_rate = hotel_config?.rooms?.custom || false;
        // Adjustments.  If it's a custom rate, we don't apply the margin discount
        const margin_discount_percentage = custom_rate
            ? 0
            : hotel_config?.adjustments?.margin_discount_percentage || 0;
        rooms.forEach((room) => {
            const key = `${room.room.id}-${room.board}-${room.occupancy}`;
            const applied_discount = (0, hotel_1.getFilteredRoomDiscounts)(hotel_config.date_of_confirmation, hotel_config?.where_when_who?.check_in_date, room.applied_discount);
            // i may need to do some checking on the applied discount at this point incase any of the options have passed etc. (e.g. early bird discounts)
            const price_summary = (0, getRoomRateSummary_1.getRoomRateSummary)(room.rate, room.occupancy, room.extra_bed, margin_discount_percentage, applied_discount);
            const total = price_summary.total_price_discounted;
            if (line_unique_rooms.some((room) => room.key === key)) {
                const existing = line_unique_rooms.find((room) => room.key === key);
                existing.total += total;
                existing.guests += room.occupancy;
            }
            else {
                line_unique_rooms.push({
                    key: key,
                    room: room.room.name.en,
                    guests: room.occupancy,
                    occupancy: room.occupancy,
                    board: room.board,
                    total: total,
                });
            }
        });
        let details = [];
        if (hotelRoomsSame) {
            details = line_unique_rooms.map((room) => {
                return {
                    title: `${(0, pluralize_1.pluralize)(hotel_config?.where_when_who?.number_of_nights, "night", "nights")} · ${room.guests / room.occupancy} x ${room.room} (${room.board}) · ${(0, pluralize_1.pluralize)(room.guests, "guest", "guests")}`,
                    per_person_price: room.total / room.guests,
                };
            });
        }
        else {
            details = transformEntries(line_unique_rooms).map((room) => {
                return {
                    title: `${(0, pluralize_1.pluralize)(hotel_config?.where_when_who?.number_of_nights, "night", "nights")} · ${room.title} · ${(0, pluralize_1.pluralize)(room.guests, "guest", "guests")}`,
                    per_person_price: room.total / room.guests,
                };
            });
        }
        items_summary.push({
            title: `Hotel (${hotel_config?.where_when_who?.hotel?.name?.en})`,
            details: details,
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: line_total,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", line_total, false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((line_total * rate).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", line_total * rate, false),
        });
    });
    // Golf Lines
    if (golfLines.length > 0) {
        let details = [];
        if (hasEqualGolfPax) {
            const total_golf = golfLines.reduce((acc, a) => acc + Number(a.total_price), 0);
            details.push({
                title: `${(0, pluralize_1.pluralize)(golfLines.length, "round", "rounds")} · ${(0, pluralize_1.pluralize)(golf_min_max_pax.max_pax, "player", "players")}`,
                per_person_price: total_golf / golf_min_max_pax.max_pax,
            });
        }
        else {
            let golf_details = [];
            golf_details = golfLines.map((line) => {
                const golf_config = line.latest_version
                    .config;
                const line_total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(golf_config, "GOLF");
                return {
                    title: `${golf_config?.course?.name?.en}`,
                    players: golf_config?.where_when_who?.number_of_golfers,
                    per_person_price: line_total / golf_config?.where_when_who?.number_of_golfers,
                };
            });
            details = formatCourses(golf_details);
        }
        // group the golf_details by the number of players.  displaying the results e.g. 18 holes at Laguna Golf Phuket, Blue Canyon Lakes + 2 more · 2 players.  so showing the first two courses in a group, how many more and then the number of players. also can you group the totals
        items_summary.push({
            title: `Golf`,
            details: details,
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: golf_pricing,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", golf_pricing, false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((golf_pricing * rate).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", golf_pricing * rate, false),
        });
    }
    // Hotel transfer lines
    if (hotel_transfers.length > 0) {
        const hotel_transfer_details = hotel_transfers.map((line) => {
            const transfer_config = line.latest_version
                .config;
            const line_total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(transfer_config, "TRANSFER");
            return {
                passengers: transfer_config?.where_when_who?.number_of_passengers,
                per_person_price: line_total / transfer_config?.where_when_who?.number_of_passengers,
            };
        });
        // group by the number of passengers.  e.g. 2 x Hotel Transfers · 2 passengers
        items_summary.push({
            title: `Hotel Transfers`,
            details: formatTrips(hotel_transfer_details),
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: hotel_transfer_pricing,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", hotel_transfer_pricing, false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((hotel_transfer_pricing * rate).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", hotel_transfer_pricing * rate, false),
        });
    }
    // Golf transfer lines
    if (golf_transfers.length > 0) {
        const golf_transfer_details = golf_transfers.map((line) => {
            const transfer_config = line.latest_version
                .config;
            const line_total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(transfer_config, "TRANSFER");
            return {
                passengers: transfer_config?.where_when_who?.number_of_passengers,
                per_person_price: line_total / transfer_config?.where_when_who?.number_of_passengers,
            };
        });
        // group by the number of passengers.  e.g. 2 x Hotel Transfers · 2 passengers
        items_summary.push({
            title: `Golf Transfers`,
            details: formatTrips(golf_transfer_details),
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: golf_transfer_pricing,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", golf_transfer_pricing, false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((golf_transfer_pricing * rate).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", golf_transfer_pricing * rate, false),
        });
    }
    // Excursion lines
    if (excursionLines.length > 0) {
        const excursion_details = excursionLines.map((line) => {
            const excursion_config = line.latest_version
                .config;
            const line_total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(excursion_config, "EXCURSION");
            return {
                title: `${excursion_config?.product?.excursion?.name?.en}`,
                pax: excursion_config?.where_when_who?.number_of_people,
                per_person_price: line_total / excursion_config?.where_when_who?.number_of_people,
            };
        });
        let details = [];
        if (hasEqualExcursionsPax) {
            details.push({
                title: `${(0, pluralize_1.pluralize)(excursionLines.length, "excursion", "excursions")} · ${(0, pluralize_1.pluralize)(excursions_min_max_pax.max_pax, "guest", "guests")}`,
                per_person_price: excursion_pricing / excursions_min_max_pax.max_pax,
            });
        }
        else {
            details = formatExcursions(excursion_details);
        }
        items_summary.push({
            title: `Excursions`,
            details: details,
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: excursion_pricing,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", excursion_pricing, false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((excursion_pricing * rate).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", excursion_pricing * rate, false),
        });
    }
    // Custom lines
    if (customLines.length > 0) {
        items_summary.push({
            title: `Extras & add-ons`,
            details: customLines.map((line) => {
                const custom_config = line.latest_version
                    .config;
                const line_total = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(custom_config, "CUSTOM");
                return {
                    title: `${custom_config?.where_when_who?.title} · ${(0, pluralize_1.pluralize)(custom_config?.where_when_who?.pax === 0
                        ? order_min_max_pax.max_pax
                        : custom_config?.where_when_who?.pax, "person", "people")} `,
                    per_person_price: line_total /
                        (custom_config?.where_when_who?.pax === 0
                            ? order_min_max_pax.max_pax
                            : custom_config?.where_when_who?.pax),
                };
            }),
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: custom_pricing,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", custom_pricing, false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((custom_pricing * rate).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", custom_pricing * rate, false),
        });
    }
    // put the default TOTALS in the pricing_summary
    pricing_summary.push({
        title: hotelLines.length > 0 ? "Total package price" : "Total price",
        currency: orderLines.length > 0 ? orderLines[0].currency : "",
        total_price: total_price,
        total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", total_price, false),
        display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
        display_total_price: Number(display_total_price.toFixed(2)),
        display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", display_total_price, false),
    });
    let scenario = 5;
    //todo
    // SCENARIO ONE - SAME PAX and SAME ROOMS
    if (hasEqualPax && hotelRoomsSame && !isOnePax) {
        scenario = 1;
        pricing_summary.push({
            title: "Price per person",
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: (total_price / order_min_max_pax.max_pax).toFixed(2),
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number((total_price / order_min_max_pax.max_pax).toFixed(2)), false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: rate > 0
                ? Number((display_total_price / order_min_max_pax.max_pax).toFixed(2))
                : 0,
            display_total_price_formatted: rate > 0
                ? (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", display_total_price / order_min_max_pax.max_pax, false)
                : null,
        });
    }
    // SCENARIO TWO - SAME PAX - DIFFERENT ROOMS
    if (hasEqualPax && !hotelRoomsSame && hotelLines.length < 2 && !isOnePax) {
        scenario = 2;
        // for all the hotel lines when comparing the  the room.id, occupancy and board, give me an array of the unique ones
        const even_split = total_excluding_hotel / order_min_max_pax.max_pax;
        let unique_rooms = [
            ...hotelLines
                .reduce((map, line) => {
                const hotel_config = line.latest_version
                    .config;
                const rooms = hotel_config?.rooms?.rooms;
                // Adjustments
                const custom_rate = hotel_config?.rooms?.custom || false;
                // Adjustments.  If it's a custom rate, we don't apply the margin discount
                const margin_discount_percentage = custom_rate
                    ? 0
                    : hotel_config?.adjustments?.margin_discount_percentage || 0;
                rooms.forEach((room) => {
                    const key = `${room.room.id}-${room.board}-${room.occupancy}`;
                    const applied_discount = (0, hotel_1.getFilteredRoomDiscounts)(hotel_config.date_of_confirmation, hotel_config?.where_when_who?.check_in_date, room.applied_discount);
                    // i may need to do some checking on the applied discount at this point incase any of the options have passed etc. (e.g. early bird discounts)
                    const price_summary = (0, getRoomRateSummary_1.getRoomRateSummary)(room.rate, room.occupancy, room.extra_bed, margin_discount_percentage, applied_discount);
                    const total = price_summary.total_price_discounted;
                    if (map.has(key)) {
                        const existing = map.get(key);
                        existing.total += total;
                        existing.guests += room.occupancy;
                    }
                    else {
                        map.set(key, {
                            room: room.room.name.en,
                            guests: room.occupancy,
                            occupancy: room.occupancy,
                            board: room.board,
                            total: total,
                        });
                    }
                });
                return map;
            }, new Map())
                .values(),
        ];
        unique_rooms = Array.from(unique_rooms);
        transformEntries(unique_rooms).forEach((entry) => {
            const entry_total = entry.total / entry.guests + even_split;
            const entry_display_total = entry_total * (rate === 0 ? 1 : rate);
            pricing_summary.push({
                title: `Price per person (${entry.title})`,
                currency: orderLines.length > 0 ? orderLines[0].currency : "",
                total_price: entry_total.toFixed(2),
                total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number(entry_total.toFixed(2)), false),
                display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
                display_total_price: rate > 0 ? Number(entry_display_total.toFixed(2)) : 0,
                display_total_price_formatted: rate > 0
                    ? (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", entry_display_total, false)
                    : "",
            });
        });
    }
    if (!hasEqualPax &&
        hotelRoomsSame &&
        hasGolfAndGolfTransfersMatchPax &&
        doesEverythingButGolfAndGolfTransfersMatchPax &&
        !isOnePax) {
        // SCENARIO THREE - DIFFERENT OVER PAX - EVEN PAX
        scenario = 3;
        const non_golfer_price = total_excluding_golf_and_golf_transfers / order_min_max_pax.max_pax;
        const golf_only_price = (total_price - total_excluding_golf_and_golf_transfers) /
            golf_min_max_pax.max_pax;
        const golfer_price = non_golfer_price + golf_only_price;
        pricing_summary.push({
            title: `Price per golfer`,
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: golfer_price.toFixed(2),
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number(golfer_price.toFixed(2)), false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: rate > 0 ? Number((golfer_price * rate).toFixed(2)) : 0,
            display_total_price_formatted: rate > 0
                ? (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", golfer_price * rate, false)
                : null,
        });
        pricing_summary.push({
            title: `Price per non-golfer`,
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: non_golfer_price.toFixed(2),
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number(non_golfer_price.toFixed(2)), false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: rate > 0 ? Number((non_golfer_price * rate).toFixed(2)) : 0,
            display_total_price_formatted: rate > 0
                ? (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", non_golfer_price * rate, false)
                : null,
        });
    }
    if (!hasEqualPax &&
        !hotelRoomsSame &&
        hasGolfAndGolfTransfersMatchPax &&
        doesEverythingButGolfAndGolfTransfersMatchPax &&
        hotelLines.length < 2 &&
        !isOnePax) {
        // SCENARIO FOUR - DIFFERENT OVER PAX - GOLF TRANSFERS MATCH - DIFFERENT ROOMS
        scenario = 4;
        const golf_per_person = golf_pricing / golf_min_max_pax.max_pax;
        const golf_transfers_per_person = golf_transfer_pricing / golf_transfers_min_max_pax.max_pax;
        const hotel_tranfers_per_person = hotel_transfer_pricing / hotel_transfers_min_max_pax.max_pax;
        const excursions_per_person = excursion_pricing / excursions_min_max_pax.max_pax;
        const custom_per_person = custom_pricing / custom_min_max_pax.max_pax;
        let unique_rooms = [
            ...hotelLines
                .reduce((map, line) => {
                const hotel_config = line.latest_version
                    .config;
                const rooms = hotel_config?.rooms?.rooms;
                // Adjustments
                const custom_rate = hotel_config?.rooms?.custom || false;
                // Adjustments.  If it's a custom rate, we don't apply the margin discount
                const margin_discount_percentage = custom_rate
                    ? 0
                    : hotel_config?.adjustments?.margin_discount_percentage || 0;
                rooms.forEach((room) => {
                    const key = `${room.room.id}-${room.board}-${room.occupancy}`;
                    const applied_discount = (0, hotel_1.getFilteredRoomDiscounts)(hotel_config.date_of_confirmation, hotel_config?.where_when_who?.check_in_date, room.applied_discount);
                    // i may need to do some checking on the applied discount at this point incase any of the options have passed etc. (e.g. early bird discounts)
                    const price_summary = (0, getRoomRateSummary_1.getRoomRateSummary)(room.rate, room.occupancy, room.extra_bed, margin_discount_percentage, applied_discount);
                    const total = price_summary.total_price_discounted;
                    if (map.has(key)) {
                        const existing = map.get(key);
                        existing.total += total;
                        existing.guests += room.occupancy;
                    }
                    else {
                        map.set(key, {
                            room: room.room.name.en,
                            guests: room.occupancy,
                            occupancy: room.occupancy,
                            board: room.board,
                            total: total,
                        });
                    }
                });
                return map;
            }, new Map())
                .values(),
        ];
        unique_rooms = Array.from(unique_rooms);
        transformEntries(unique_rooms).forEach((entry) => {
            const entry_total = entry.total / entry.guests +
                (golf_per_person +
                    golf_transfers_per_person +
                    hotel_tranfers_per_person +
                    excursions_per_person +
                    custom_per_person);
            const entry_display_total = (entry.total * rate) / entry.guests +
                (golf_per_person +
                    golf_transfers_per_person +
                    hotel_tranfers_per_person +
                    excursions_per_person +
                    custom_per_person) *
                    rate;
            pricing_summary.push({
                title: `Price per golfer (${entry.title})*`,
                currency: orderLines.length > 0 ? orderLines[0].currency : "",
                total_price: entry_total.toFixed(2),
                total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number(entry_total.toFixed(2)), false),
                display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
                display_total_price: rate > 0 ? Number(entry_display_total.toFixed(2)) : 0,
                display_total_price_formatted: rate > 0
                    ? (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", entry_display_total, false)
                    : null,
            });
        });
        transformEntries(unique_rooms).forEach((entry) => {
            const entry_total = entry.total / entry.guests +
                (hotel_tranfers_per_person + excursions_per_person + custom_per_person);
            const entry_display_total = (entry.total * rate) / entry.guests +
                (hotel_tranfers_per_person +
                    excursions_per_person +
                    custom_per_person) *
                    rate;
            pricing_summary.push({
                title: `Price per non golfer (${entry.title})*`,
                currency: orderLines.length > 0 ? orderLines[0].currency : "",
                total_price: entry_total.toFixed(2),
                total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number(entry_total.toFixed(2)), false),
                display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
                display_total_price: rate > 0 ? Number(entry_display_total.toFixed(2)) : 0,
                display_total_price_formatted: rate > 0
                    ? (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", entry_display_total, false)
                    : null,
            });
        });
        footnote =
            "* As we don’t know what room types the non-golfers are staying in, we have provided per person pricing for all scenarios.";
    }
    if (pricing_summary.length === 1 && !isOnePax) {
        pricing_summary.push({
            title: "Price per person*",
            currency: orderLines.length > 0 ? orderLines[0].currency : "",
            total_price: (total_price / order_min_max_pax.max_pax).toFixed(2),
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].currency : "", Number((total_price / order_min_max_pax.max_pax).toFixed(2)), false),
            display_currency: orderLines.length > 0 ? orderLines[0].display_currency : "",
            display_total_price: Number((display_total_price / order_min_max_pax.max_pax).toFixed(2)),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(orderLines.length > 0 ? orderLines[0].display_currency : "", display_total_price / order_min_max_pax.max_pax, false),
        });
    }
    if (scenario === 5 && !isOnePax) {
        footnote =
            "* This is an estimate. It is not possible to calculate an exact per person price without assigning each guest to each line.";
    }
    return {
        pricing_summary: pricing_summary,
        items_summary: items_summary,
        footnote: footnote,
    };
};
exports.getPerPersonPricingSummary = getPerPersonPricingSummary;
// Helper function to convert numerical occupancy to descriptive string
function occupancyDescription(occupancy) {
    const descriptions = [
        "Single occupancy",
        "Double occupancy",
        "Triple occupancy",
        "Quadruple occupancy",
    ];
    return descriptions[occupancy - 1] || `${occupancy}-Person Occupancy`;
}
function transformEntries(entries) {
    const uniqueFields = ["room", "occupancy", "board"];
    const fieldValues = uniqueFields.reduce((acc, field) => {
        acc[field] = new Set(entries.map((entry) => entry[field]));
        return acc;
    }, {});
    return entries.map((entry) => {
        const differences = uniqueFields.filter((field) => fieldValues[field].size > 1);
        const title = differences
            .map((diff) => {
            if (diff === "occupancy") {
                return occupancyDescription(entry[diff]);
            }
            return entry[diff];
        })
            .join(", ");
        return {
            title: title,
            guests: entry.guests,
            total: entry.total,
        };
    });
}
function formatCourses(courses) {
    // Group courses by the number of players
    const groupedCourses = {};
    courses.forEach((course) => {
        if (!groupedCourses[course.players]) {
            groupedCourses[course.players] = [];
        }
        groupedCourses[course.players].push(course);
    });
    // Format the grouped courses
    const formattedCourses = [];
    for (const players in groupedCourses) {
        const courses = groupedCourses[players];
        const titles = courses.map((course) => course.title);
        const total_price = courses.reduce((sum, course) => sum + course.per_person_price, 0);
        let title = titles.join(", ");
        if (titles.length > 1) {
            title = `${titles.slice(0, -1).join(", ")} + ${titles.length - 1} more · ${players} players`;
        }
        else {
            title = `${titles[0]} · ${players} players`;
        }
        formattedCourses.push({
            title: title,
            per_person_price: total_price,
        });
    }
    return formattedCourses;
}
function formatExcursions(excursions) {
    // Group courses by the number of players
    const groupedExcursions = {};
    excursions.forEach((excursion) => {
        if (!groupedExcursions[excursion.pax]) {
            groupedExcursions[excursion.pax] = [];
        }
        groupedExcursions[excursion.pax].push(excursion);
    });
    // Format the grouped courses
    const formattedExcursions = [];
    for (const pax in groupedExcursions) {
        const excursions = groupedExcursions[pax];
        const titles = excursions.map((excursion) => excursion.title);
        const total_price = excursions.reduce((sum, excursion) => sum + excursion.per_person_price, 0);
        let title = titles.join(", ");
        if (titles.length > 1) {
            title = `${titles.slice(0, -1).join(", ")} + ${titles.length - 1} more · ${pax} people`;
        }
        else {
            title = `${titles[0]} · ${pax} people`;
        }
        formattedExcursions.push({
            title: title,
            per_person_price: total_price,
        });
    }
    return formattedExcursions;
}
function formatTrips(trips) {
    const tripMap = {};
    trips.forEach((trip) => {
        if (!tripMap[trip.passengers]) {
            tripMap[trip.passengers] = { count: 0, total_price: 0 };
        }
        tripMap[trip.passengers].count += 1;
        tripMap[trip.passengers].total_price += trip.per_person_price;
    });
    const formattedTrips = [];
    for (const passengers in tripMap) {
        const { count, total_price } = tripMap[passengers];
        formattedTrips.push({
            title: `${(0, pluralize_1.pluralize)(count, "trip", "trips")} · ${(0, pluralize_1.pluralize)(Number(passengers), "passenger", "passengers")}`,
            per_person_price: total_price,
        });
    }
    return formattedTrips;
}
